import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@context/ThemeContext'
import { I18nProvider } from '@i18n/I18nProvider'
import App from './App'

// Design tokens — auto-generated from the Figma DTCG exports in `tokens/` by
// `style-dictionary.config.mjs`. Loaded before global styles so every CSS
// custom property referenced downstream is already defined.
//   1. base  → primitives, spacing, radius, font, typography  (always active)
//   2. light → semantic + component colours                   (default + [data-theme='light'])
//   3. dark  → semantic + component colours                   ([data-theme='dark'])
import '@styles/generated/tokens-base.css'
import '@styles/generated/tokens-light.css'
import '@styles/generated/tokens-dark.css'

import '@styles/global.scss'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </I18nProvider>
  </StrictMode>,
)
